// extracted by mini-css-extract-plugin
export var width100 = "G_v d_v";
export var design3Pos = "G_wF d_Z";